/*
 * Project Que drop calendar.
 * Recalculates which monthly drops a new member gets, based on today's date
 * in the club's time zone. Server-rendered values are used until this runs.
 */
(function () {
  function todayParts(timeZone) {
    try {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }).formatToParts(new Date());
      const out = {};
      parts.forEach(function (p) {
        if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10);
      });
      return out;
    } catch (e) {
      const d = new Date();
      return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    }
  }

  function fill(template, values) {
    return template.replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function init(root) {
    const cutoffDay = parseInt(root.dataset.cutoffDay, 10) || 7;
    const timeZone = root.dataset.timeZone || 'America/Edmonton';
    const today = todayParts(timeZone);

    let year = today.year;
    let startMonth = today.day > cutoffDay ? today.month + 1 : today.month;
    let nextYear = false;
    if (startMonth > 12) {
      startMonth = 1;
      year += 1;
      nextYear = true;
    }

    const months = Array.prototype.slice.call(root.querySelectorAll('[data-pq-month]'));
    const names = months.map(function (el) {
      return el.dataset.monthName;
    });

    months.forEach(function (el) {
      const n = parseInt(el.dataset.pqMonth, 10);
      let state = 'included';
      if (n < startMonth) state = 'shipped';
      if (n === startMonth) state = 'first';
      el.dataset.state = state;
    });

    const count = 12 - startMonth + 1;
    const firstName = names[startMonth - 1] || '';
    const lastName = names[11] || '';
    const values = {
      count: count,
      first: firstName,
      last: lastName,
      year: year,
      cutoff: cutoffDay,
      drop_day: cutoffDay + 1,
    };

    root.querySelectorAll('[data-pq-year]').forEach(function (el) {
      el.textContent = year;
    });
    root.querySelectorAll('[data-pq-count]').forEach(function (el) {
      el.textContent = count;
    });
    root.querySelectorAll('[data-pq-template]').forEach(function (el) {
      const template = nextYear && el.dataset.pqTemplateNextYear ? el.dataset.pqTemplateNextYear : el.dataset.pqTemplate;
      el.textContent = fill(template, values);
    });

    document.querySelectorAll('[data-pq-variants]').forEach(function (el) {
      const ids = el.dataset.pqVariants.split(',');
      const id = ids[startMonth - 1];
      if (id && el.dataset.pqBase) el.setAttribute('href', el.dataset.pqBase + '?variant=' + id);
    });

    document.querySelectorAll('[data-pq-hero-status]').forEach(function (el) {
      const template = nextYear && el.dataset.pqTemplateNextYear ? el.dataset.pqTemplateNextYear : el.dataset.pqTemplate;
      if (template) el.innerHTML = fill(template, values).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    });
  }

  function run() {
    document.querySelectorAll('[data-pq-calendar]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
